import clsx from 'clsx';

type FieldWrapperProps = {
	legend: string;
	children: React.ReactNode;
	required?: boolean;
	variant: 'column' | 'row' | 'default';
};

export const FieldWrapper = ({legend, children, required, variant}: FieldWrapperProps) => {
	return (
		<fieldset>
			<legend
				className={clsx(
					'text-2xl',
					'mb-6',
					required && 'after:content-["*"]',
					required && 'after:ml-0.5',
					required && 'after:text-red-500',
				)}
			>
				{legend}
			</legend>

			<div
				className={clsx(
					'gap-2',
					variant === 'column' && ['grid', 'grid-cols-1'],
					variant === 'default' && ['flex', 'flex-wrap', 'flex-col', 'md:flex-row'],
					variant === 'row' && ['flex', 'flex-wrap', 'flex-row'],
				)}
			>
				{children}
			</div>
		</fieldset>
	);
};
